export default __webpack_public_path__ + "static/media/skill-new.43efaf56.png";